<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Unit</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Unit</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="unit.id === null">New</span>
                  <span v-else>{{ unit.unit_no }}</span>
                </li>
              </ol>
              <!-- <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button> -->
              <button type="button" @click="saveSchedule" class="btn btn-sm btn-soft-primary pull-left" v-if="unit.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
              <button type="button" @click="update" class="btn btn-sm btn-soft-primary pull-left" v-if="unit.id != null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <!-- <button type="button" @click="validate" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Validate</button>
              <button type="button" @click="calcFuelTotal" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Calc Fuel</button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-list">
            <div class="card-header">
              <h5 v-if="unit.unit_no === null">New</h5>
              <h5 v-else>{{ unit.unit_no }}</h5>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <button type="button" class="btn btn-sm btn-info" @click="getAsset" data-toggle="modal" data-target="#modalAssetList" data-backdrop="static" data-keyboard="false"><i class="fa fa-search"></i></button>
                  <div>
                    <img :src="`${publicPath}asset/img/product.png`" v-if="unit.asset.picture === null">
                    <img :src="unit.asset.picture" v-else/>
                  </div>
                  <div class="unit-text">
                    <h5 class="text-left">
                      {{ unit.asset.asset_name }} <span v-if="unit.asset.internal_number !== null"><b>({{ unit.asset.internal_number }})</b></span>
                      &nbsp;
                      <span class="badge badge-success" v-if="unit.asset.condition === 'ready'">{{ unit.asset.condition }}</span>
                      <span class="badge badge-warning" v-else>{{ unit.asset.condition }}</span>
                    </h5>
                  </div>
                  <!-- <pre>{{ unit.asset }}</pre> -->
                </div>
                <div class="col-md-4">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Date</dt>
                    <dd class="col-md-8">
                      <datetime v-model="unit.unit_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                    </dd>

                    <dt class="col-md-4">Type</dt>
                    <dd class="col-md-8">
                      <select class="form-control" v-model="unit.type_id">
                        <option v-for="t in unitTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                      </select>
                    </dd>

                    <dt class="col-md-4">Company</dt>
                    <dd class="col-md-8">
                      <select class="form-control" v-model="unit.company_no">
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                    </dd>

                    <dt class="col-md-4">Customer:</dt>
                    <dd class="col-md-8">
                      <button type="button" data-toggle="modal" data-target="#modalCustomerForm" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-hard-primary mr-1">+ New</button>
                      <button type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-hard-primary" @click="getCustomerList">List</button>
                    </dd>
                    <dt class="col-md-4">Customer No.</dt>
                    <dd class="col-md-8">
                      <i>{{ unit.customer_no }}</i>
                    </dd>

                    <dt class="col-md-4">Name:</dt>
                    <dd class="col-md-8">
                      {{ unit.customer.name }}
                    </dd>

                    <dt class="col-md-4">Phone:</dt>
                    <dd class="col-md-8">
                      {{ unit.customer.phone }}
                    </dd>
                    <dt class="col-md-4">Product/Service</dt>
                    <dd class="col-md-8">
                      <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="unit.product_no" />
                    </dd>
                  </dl>
                  <hr>
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Check Person</dt>
                    <dd class="col-md-8">
                      <b>[{{ unit.check_person}}]</b> {{ unit.check_person_name }}
                    </dd>
                    <dt class="col-md-4">Check Date</dt>
                    <dd class="col-md-8">
                      <datetime v-model="unit.storage_date" type="datetime" class="form-control" value-zone="local" zone="local"></datetime>
                    </dd>
                  </dl>
                </div>
                <div class="col-md-4">
                  <dl class="dl-custom row">
                    <dt class="col-md-4">Schedule Date</dt>
                    <dd class="col-md-8">
                      <datetime v-model="unit.schedule_date" type="datetime" class="form-control" value-zone="local" zone="local"></datetime>
                    </dd>

                    <dt class="col-md-4">Start Date</dt>
                    <dd class="col-md-8">
                      <datetime v-model="unit.start_date" type="datetime" class="form-control" value-zone="local" zone="local"></datetime>
                    </dd>

                    <dt class="col-md-4">Finish Date</dt>
                    <dd class="col-md-8">
                      <datetime v-model="unit.finish_date" type="datetime" class="form-control" value-zone="local" zone="local"></datetime>
                    </dd>
                  </dl>
                  <dl class="dl-custom row">
                    <dt class="col-md-4">Sale No.</dt>
                    <dd class="col-md-8">
                      <b>{{ unit.sale_no }}</b>
                    </dd>

                    <dt class="col-md-4">Notes</dt>
                    <dd class="col-md-8">
                      <textarea v-model="unit.notes" class="form-control" rows="5"></textarea>
                    </dd>
                    <dt class="col-md-4">Fuel Bar</dt>
                    <dd class="col-md-8">{{ unit.fuel_bar }}</dd>
                    <dt class="col-md-4">Fuel Total</dt>
                    <dd class="col-md-8">{{ unit.fuel_total }} {{ unit.fuel_uom }}</dd>
                  </dl>
                  <hr>
                  <div class="row">
                    <div class="col-md-12">
                      <h5>Fuel</h5>
                      <div class="table-responsive">
                        <table class="table table-sm table-item table-striped">
                          <thead>
                            <th>Queue</th>
                            <th>Status</th>
                            <th>Bar</th>
                            <th>#</th>
                          </thead>
                          <tbody>
                            <tr v-for="(f, index) in unit.fuels" :key="index">
                              <td>{{ f.queue }}</td>
                              <td>
                                <select v-model="f.status" class="form-control">
                                  <option value="start">Start</option>
                                  <option value="additional">Additional</option>
                                  <option value="finish">Finish</option>
                                </select>
                              </td>
                              <td><input type="text" v-model="f.bar" class="form-control"/></td>
                              <td>
                                <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeFuel(index)"><i class="fa fa-trash"></i></button>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4">
                                <span @click="addFuel" class="link-secondary" >+ Add Fuel</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in unit.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div> -->
      <AssetModal @selectAsset="selectAsset"/>
      <CustomerFormModal @createCustomer="createCustomer" />
      <UnitCustomerModal @selectCustomerList="selectCustomerList" />
      <div class="row">
        <div class="col-md-6"><pre>{{ unit }}</pre></div>
      </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { mapState } from 'vuex'
import AssetModal from '@/components/asset/AssetModal.vue'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import UnitCustomerModal from '@/components/unit/UnitCustomerModal.vue'
import { getHeader, unitUrl } from '../../config'
import Axios from 'axios'

export default {
  name: 'UnitForm',
  props: ['unit'],
  components: {
    Loading,
    AssetModal,
    CustomerFormModal,
    UnitCustomerModal
  },
  data () {
    return {
      alert: [],
      publicPath: process.env.BASE_URL,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      unitTypeList: state => state.units.unitTypeList,
      companyList: state => state.companies.companyList,
      uomList: state => state.uom.uomList,
      productListSelect: state => state.products.productListSelect
    }),
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async calcFuelTotal () {
      var array = this.unit.fuels
      var countBar = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'start') {
          countBar += parseFloat(array[i].bar)
        } else if (array[i].status === 'finish') {
          countBar -= parseFloat(array[i].bar)
        }
      }
      this.unit.fuel_bar = countBar
      var asset = this.unit.asset
      var fuelTotal = countBar * asset.fuel_qty_reference
      this.unit.fuel_total = fuelTotal
      this.unit.fuel_uom = asset.fuel_uom_reference
    },
    async update () {
      this.alert = []
      await this.validate()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.calcFuelTotal()
      var body = {
        id: this.unit.id,
        unit_no: this.unit.unit_no,
        unit_date: this.unit.unit_date,
        type_id: this.unit.type_id,
        name: this.unit.name,
        alias: this.unit.alias,
        schedule_date: this.unit.schedule_date,
        storage_date: this.unit.storage_date,
        start_date: this.unit.start_date,
        finish_date: this.unit.finish_date,
        sale_no: this.unit.sale_no,
        notes: this.unit.notes,
        company_no: this.unit.company_no,
        asset_no: this.unit.asset_no,
        customer_no: this.unit.customer_no,
        check_person: this.unit.check_person,
        created_by: this.unit.created_by,
        status: this.unit.status,
        lock: this.unit.lock,
        product_no: this.unit.product_no,
        fuel_bar: this.unit.fuel_bar,
        fuel_total: this.unit.fuel_total,
        fuel_uom: this.unit.fuel_uom,
        fuels: this.unit.fuels
      }
      await Axios.put(unitUrl + '/' + this.unit.id, body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Succses', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    recalQueue () {
      var ascending = true
      var col = 'queue'
      var array = this.unit.fuels.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
      var count = 0
      for (let i = 0; i < array.length; i++) {
        count += 1
        console.log(count)
        this.unit.fuels[i].queue = count
      }
    },
    async removeFuel (index) {
      var fuel = this.unit.fuels[index]
      if (typeof fuel.id === 'undefined') {
        await this.unit.fuels.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(unitUrl + '/fuel/' + fuel.id, { headers: getHeader() })
              .then(response => {
                this.unit.fuels.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
      await this.recalQueue()
    },
    addFuel () {
      var max = 0
      var status = ''
      if (this.unit.fuels.length > 0) {
        var fuel = this.unit.fuels.reduce((a, b) => Number(a.queue) > Number(b.queue) ? a : b)
        max = fuel.queue + 1
      } else {
        max = 1
      }
      if (max === 1) {
        status = 'start'
      }
      var obj = {
        unit_no: this.unit.unit_no,
        unit_date: this.unit.unit_date,
        queue: max,
        bar: '0',
        qty: '0',
        uom_id: null,
        status: status,
        warehouse_no: null,
        company_no: this.unit.company_no
      }
      this.unit.fuels.push(obj)
    },
    async selectCustomerList (customer) {
      this.unit.customer_no = customer.customer_no
      this.unit.customer = customer
    },
    createCustomer: function (customer) {
      this.unit.customer_no = customer.customer_no
      this.unit.customer = customer
    },
    getCustomerList () {
      this.$store.dispatch('getCustomerList')
    },
    selectAsset (asset) {
      this.unit.asset_no = asset.asset_no
      this.unit.asset = asset
      this.unit.asset.picture = asset.picture + '?size='
    },
    getAsset () {
      this.$store.dispatch('getAssetList')
    },
    backParent () {
      this.alert = []
      this.$emit('backClicked')
    },
    async validate () {
      if (this.unit.asset_no == null) {
        this.alert.push('<b>Unit</b> harus dipilih terlebih dahulu')
      }
      if (this.unit.type_id === 'customer') {
        if (this.unit.customer_no === null) {
          this.alert.push('<b>Customer</b> harus diinput terlebih dahulu')
        }
      }
      // create schedule
      if (this.unit.id === null) {
        if (this.unit.schedule_date === null) {
          this.alert.push('<b>Jadwal</b> harus diinput terlebih dahulu')
        }
      }
    },
    async saveSchedule () {
      this.alert = []
      await this.validate()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.calcFuelTotal()
      var body = {
        unit_no: this.unit.unit_no,
        unit_date: this.unit.unit_date,
        type_id: this.unit.type_id,
        name: this.unit.name,
        alias: this.unit.alias,
        schedule_date: this.unit.schedule_date,
        storage_date: this.unit.storage_date,
        start_date: this.unit.start_date,
        finish_date: this.unit.finish_date,
        sale_no: this.unit.sale_no,
        notes: this.unit.notes,
        company_no: this.unit.company_no,
        asset_no: this.unit.asset_no,
        customer_no: this.unit.customer_no,
        check_person: this.unit.check_person,
        created_by: this.unit.created_by,
        status: 'scheduled',
        lock: false
      }
      console.log(body)
      await Axios.post(unitUrl, body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Succses', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    }
  }
}
</script>

<style>
.unit-text {
  display: flex;
  justify-content: center;
}
</style>
